import React, { useState, useEffect, useCallback } from 'react';
import { Button, Modal, Form, Card, Spinner, Alert } from 'react-bootstrap';
import api from './api';

function OlcuBirimiYonetimi() {
  const [birimler, setBirimler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenBirim, setDuzenlenenBirim] = useState(null);

  const birimleriGetir = useCallback(async () => {
    try {
      const response = await api.get('/diyetisyen/olcu-birimleri');
      setBirimler(response.data);
    } catch (err) {
      setError("Ölçü birimleri yüklenirken bir hata oluştu.");
      console.error("Ölçü birimleri getirilemedi:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { birimleriGetir(); }, [birimleriGetir]);

  const handleSil = async (birimId) => {
    if (!window.confirm('Bu ölçü birimini silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/diyetisyen/olcu-birimleri/${birimId}`);
      birimleriGetir();
    } catch (err) {
      alert(err.response?.data?.mesaj || 'Silme işlemi başarısız');
    }
  };
  
  const handleModalOpen = (birim = null) => {
    setDuzenlenenBirim(birim);
    setShowModal(true);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const ad = e.target.elements.ad.value;
    const isUpdating = !!duzenlenenBirim?.id;
    const url = isUpdating ? `/diyetisyen/olcu-birimleri/${duzenlenenBirim.id}` : '/diyetisyen/olcu-birimleri';
    const method = isUpdating ? 'put' : 'post';
    try {
      await api[method](url, { ad });
      setShowModal(false);
      birimleriGetir();
    } catch (err) {
      alert(`Hata: ${err.response?.data?.mesaj || 'İşlem başarısız'}`);
    }
  };

  if (loading) return <Spinner animation="border" variant="light" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Card className="glass-card text-white">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title as="h5">Ölçü Birimi Listesi</Card.Title>
          <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Ölçü Birimi Ekle</Button>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Ad</th>
                <th style={{ width: '150px' }} className="text-end">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {birimler.map((birim) => (
                <tr key={birim.id}>
                  <td data-label="Ad">{birim.ad}</td>
                  <td data-label="İşlemler" className="text-end">
                    <Button variant="warning" size="sm" onClick={() => handleModalOpen(birim)}>Düzenle</Button>
                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(birim.id)}>Sil</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{duzenlenenBirim?.id ? 'Ölçü Birimi Düzenle' : 'Yeni Ölçü Birimi Ekle'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleFormSubmit}>
            <Form.Group>
              <Form.Label>Birim Adı</Form.Label>
              <Form.Control name="ad" type="text" defaultValue={duzenlenenBirim?.ad || ''} required />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={() => setShowModal(false)} className="me-2">İptal</Button>
              <Button variant="primary" type="submit">Kaydet</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Card>
  );
}
export default OlcuBirimiYonetimi;